import { useSelector } from 'react-redux'
import { ReactComponent as MiniDivisionBadge } from '../../../../assets/images/common/icons/mini-division-badge.svg'
import { ReactComponent as StandaloneLogo } from '../../../../assets/images/common/icons/standalone-logo.svg'
import { DATETIME_FORMAT, getMomentInCommunityTimezoneReversed } from '../../../../utility/datesHelper'
import { yardageByLevel, levelColors } from '../../../../utility/curriculumHelper'
import { splitArray } from '../../../../utility/arrayHelper'
import moment from 'moment'

import classes from './PairingsReport.module.scss'
import classNames from 'classnames'

const PairingsReport = () => {
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)
  const event = useSelector(state => state.nineHoleEvent)
  const startTime = getMomentInCommunityTimezoneReversed(moment(event.eventDate), timezone, DATETIME_FORMAT)

  let groupedPairingGroups = event.pairings.pairingGroups.flatMap(group => {
    const groups = []
    for (let i = 0; i < group.users.length; i += 4) {
      groups.push ({
        ...group,
        users: group.users.slice(i, i + 4),
      })
    }
    return groups.length ? groups : [{ ...group, users: [] }]
  })

  groupedPairingGroups = splitArray(groupedPairingGroups, 16)

  return (
    <div id='pairings' className={classes.pairingsReport}>
      {groupedPairingGroups.map((pairingGroups, index) =>
        <div key={index} className='PairingsTeeSheetPage p-4'>
          <div className='d-flex justify-content-between w-100'>
            <div className={classes.title}>
              Pairing Groups - {event.name}
            </div>
            <StandaloneLogo className={classes.logo}/>
          </div>

          <div className={classes.date}>
            {startTime.format('MMM D, YYYY h:mma')} - {startTime.clone().add(1, 'hours').format('h:mma')}
          </div>
          <div className={classes.header}>
            <div className={classes.startTime}>Time</div>
            <div className={classes.hole}>Hole</div>
            <div className='pl-5'>Players</div>
          </div>
          <div>
            {pairingGroups.map((group) => (
              <div
                key={group.id}
                className={classes.pairingGroupRow}
              >
                <div className={classes.startTime}>
                  {getMomentInCommunityTimezoneReversed(
                    moment(group.startTime),
                    timezone,
                    DATETIME_FORMAT
                  ).format('LT')}
                </div>
                <div className={classes.hole}>
                  {`${group.startHole.value || ''} ${group.playersGroup.value || ''}`}
                </div>
                <div className={classes.players}>
                  <div className='d-flex flex-wrap'>
                    {group.users?.filter(Boolean).map((student, index) => (
                      <div key={index} className={classNames('d-flex flex-column', classes.studentWrapper)}>
                        <div>
                          <MiniDivisionBadge fill={levelColors[student.level]} className={classes.levelBadge}/>
                          <span className={classes.studentLevel} style={{ color: levelColors[student.level] }}>{student.level}</span>

                          <span className={classes.studentName}>
                            {student.firstName} {student.lastName}
                          </span>
                        </div>
                        <p className={classes.studentYardage}>
                          {student.level < 6 ? yardageByLevel[student.level] / 9 + ' yds' : 'Full Tee Box'}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default PairingsReport
